<template>
	<div class="not-found">
		<img src="@/assets/img/logarithmic_gmt.gif" class="fix-1">
		<img src="@/assets/img/logarithmic_gmt.gif" class="fix-2">
		<div class="not-found-left">
			<img src="@/assets/img/404.png">
		</div>
		<div class="not-found-right">
			<img src="@/assets/img/404.png">
		</div>
		
		<div class="not-found-text">
			<p style="display: block">Данная страница ещё не создана.</p>
			<ul>
				<li>
					<a href="/about#contact">Хочу создать страницу</a>
				</li>
				<li>
					<a href="/#curves_card">Буду изучать другие кривые</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	name: '404',
}
</script>

<style scoped lang="scss">
.not-found{
	text-align: center;
	width: 320px;
	margin-left: auto;
	margin-right: auto;
	position: relative;
	.not-found-left{
		display: inline-block;
		
		img {
			width: 145px;
			margin-right: 20px;
		}
	}
	.not-found-right{
		display: inline-block;
		img {
			width: 145px;
		}
	}
	.not-found-text{
		li {
			text-align: left;
		}
	}
	.fix-1 {
		position: absolute;
		z-index: 3;
		left: 57px;
		top: 53px;
		width: 40px;
		border-radius: 18px;
	}
	.fix-2 {
		position: absolute;
		z-index: 3;
		right: 57px;
		width: 40px;
		top: 53px;
		border-radius: 20px;
	}
}
</style>
